import {
  useLeanUnreadNotificationsCountQuery,
  useUnreadNotificationsCountQuery,
} from '@/generated/graphql';
import {useBrand} from '@/contexts/BrandContext';
import {useSubscribeToNotifications} from '@/hooks/useInitializeNotifications';
import NotificationsIcon from '@mui/icons-material/Notifications';
import {useGlobalFeatures} from '@ark/react';
import {Badge, IconButton, useTheme} from '@mui/material';
import {makeStyles} from '@mui/styles';
import React from 'react';
import {useNavigate} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  iconButton: {
    display: 'flex',
    padding: 6,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    alignSelf: 'stretch',
  },
  notificationsIcon: {
    width: 24,
    height: 24,
    transition: theme.transitions.create(['color'], {
      duration: theme.transitions.duration.short,
    }),
  },
}));

const NotificationsMenu: React.FC = () => {
  const styles = useStyles();
  const {palette} = useTheme();
  const navigate = useNavigate();
  const {assets} = useBrand();
  const [globalFeatures] = useGlobalFeatures();
  const isLeanFeed = !!globalFeatures.leanNotificationFeed;

  const unionQuery = useUnreadNotificationsCountQuery({skip: isLeanFeed});
  const leanQuery = useLeanUnreadNotificationsCountQuery({
    skip: !isLeanFeed,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
  });

  const unreadCount = isLeanFeed
    ? (leanQuery.data?.leanNotifications?.totalCount ?? 0)
    : (unionQuery.data?.notifications?.totalCount ?? 0);
  const refetch = isLeanFeed ? leanQuery.refetch : unionQuery.refetch;

  useSubscribeToNotifications(() => {
    refetch();
  });

  React.useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      //@ts-ignore
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    //@ts-ignore
    link.href = unreadCount > 0 ? assets.faviconNotification : assets.favicon;
  }, [unreadCount, assets]);

  const handleNavigate = () => {
    navigate('/notifications');
  };

  return (
    <IconButton
      aria-label="Open notifications"
      className={styles.iconButton}
      sx={{
        '&:hover': {
          backgroundColor: palette.action.hover,
        },
      }}
      color="default"
      onClick={handleNavigate}
    >
      <Badge
        badgeContent={unreadCount}
        color="error"
        overlap="circular"
        max={99}
        anchorOrigin={{vertical: 'top', horizontal: 'left'}}
      >
        <NotificationsIcon className={styles.notificationsIcon} />
      </Badge>
    </IconButton>
  );
};

export default NotificationsMenu;
